import { useEffect, useState } from "react";
import { StatsRowModal } from "../components/customModals";
import { KpiComp } from "../components/kpiComp";
import { GridLayout } from "../components/layout";
import { DropdownButton, StandardButton } from "../atoms/buttons";
import { IconAtom2 } from "../atoms/iconAtom";
import { fetchAPI, postAPI } from "../api/api";
import { SkeletonCardModules } from "../atoms/skeletonloaders";

export function StatsRow({ stats, keys, setKeys, loadStats, availableMetrics, loading, setPeriod, period}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStatKey, setSelectedStatKey] = useState(null);


  const handleStatClick = (key) => {
    setSelectedStatKey(key);
    setModalVisible(true);
  };



  return (
    <>


      <GridLayout
        key={`row-adas`}
        className="stats-grid"
        gap="1rem"
        columnsTemplate={
          "1fr 1fr 1fr 1fr"

        }
        style={{ marginRight: "1rem" }}
      >
        {stats.map((stat, index) => {


          let kpiValue;
          if (stat?.name === "simple_popular" && !stat.total_metric) {
            kpiValue = "Geen cursus";
          } else {
            kpiValue = stat.total_metric ?? 0;
          }
          return (
            <div
              key={index}
              style={{ position: "relative", cursor: "pointer" }}
              onClick={() => handleStatClick(index)}
            >
              <KpiComp
                editClass={index > 3 ? "no-margin-top" : ""}
                title={stat.name || index}
                value={kpiValue}
                percentage={stat.difference_status}
                icon2={stat.icon_name}

                data={
                  <div className="period-text">
                    {stat.period} maanden geleden
                  </div>
                }

              />
            </div>
          );
        })}
        {stats.length < 8 && (
          <div
            className="add-btn"
            key="add-icon"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedStatKey(null);
              setModalVisible(true);
            }}
          >
            <IconAtom2
              style={{
                color: "var(--primary-500)",
                backgroundColor: "transparent",
              }}
              color="icon-spin"
              icon2="plus"
              iconSize={50}
            />
          </div>
        )}
      </GridLayout>


      {modalVisible && (
        <StatsRowModal
          visible={modalVisible}
          dismiss={() => setModalVisible(false)}
          keys={keys}
          currentKey={selectedStatKey}
          onSave={loadStats}

          activeIndex={selectedStatKey}

          stat={stats[selectedStatKey]}
          period={period}
          setPeriod={setPeriod}
        />
      )}
    </>
  );
}
